import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { type ToolUsageResponse } from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

import { toolLabel } from './analytics.labels';

const { coachingAnalytics } = appStrings.modules;

export const useAgentContext = (data: ToolUsageResponse) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.toolUsage.title,
    display:
      'A card within Engagement, tabbed between unique students and total sessions, with a bar per tool.',
    detail: [
      coachingAnalytics.toolUsage.info,
      'The per-tool counts overlap wherever a student used more than one, so they cannot be summed — with_any_tool is the number who used at least one.',
    ].join('\n\n'),
    data: {
      students: {
        total: data.students.total,
        with_any_tool: data.students.with_any_tool,
      },
      tools: data.tools.map((tool) => ({
        tool: toolLabel(tool.tool),
        unique_students: tool.unique_students,
        total_sessions: tool.total_sessions,
      })),
    },
  });
};
